import React from 'react';
import { connect } from 'react-redux';

import GrantEmrManagerRoleButton from './components/GrantEmrManagerRoleButton';
import RevokeEmrManagerRoleButton from './components/RevokeEmrManagerRoleButton';
import Loader from './components/Loader';

import {
  shouldDisplayGrantRevokeButtonsSelector,
  fetchGrantRevokeEmrManagerRoleButtonsLoadingSelector,
  fetchGrantRevokeEmrManagerRoleButtonsErrorSelector,
  hasEmrManagerRoleSelector
} from './redux/selectors';

import styles from './styles.module.scss';

const GrantRevokeEmrManagerRole = ({ adminId, loading, error, shouldDisplayButtons, hasEmrManagerRole }) => {
  if (loading) return <Loader />;
  if (error) return "";
  if (!shouldDisplayButtons) return "";

  return(
    <span className={styles.grantRevokeEmrManagerRoleButtons}>
      <span>
        {hasEmrManagerRole ? (
          <RevokeEmrManagerRoleButton adminId={adminId} />
        ) : (
          <GrantEmrManagerRoleButton adminId={adminId} />
        )}
      </span>
    </span>
  )
}

const mapStateToProps = (state, adminId) => ({
  loading: fetchGrantRevokeEmrManagerRoleButtonsLoadingSelector(state),
  error: fetchGrantRevokeEmrManagerRoleButtonsErrorSelector(state),
  shouldDisplayButtons: shouldDisplayGrantRevokeButtonsSelector(state),
  hasEmrManagerRole: hasEmrManagerRoleSelector(state, adminId)
});

export default connect(mapStateToProps)(GrantRevokeEmrManagerRole);
